module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/doctors/noimage_man-4f91c3f04e082a726d6b1858c124c471.svg";